// ignore-string-externalization

import { useCallback, useEffect } from 'react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { ModuleType } from '../Module/types';
import { defaultTheme } from '../Theme';
import { useLayoutContext } from '../Layout';
import { JumpLinkHeroModuleType } from '../Module/JumpLinkHeroModule';

export const useDynamicNavBarColor = (
  module?: Partial<ModuleType>,
  isNavBarFullBleed = true,
) => {
  const { setNavBarBackground, setNavBarTextColor, setNavBarBleed } =
    useLayoutContext();

  const updateNavBar = useCallback(
    (mod?: Partial<JumpLinkHeroModuleType>) => {
      // look at the mod type and infer colors
      if (
        typeof mod !== 'undefined' &&
        mod.contentType &&
        mod.contentType.toString() === 'jumpLinkHeroModule'
      ) {
        const bk =
          mod.modulePrimaryColors?.theme === 'dark' ? '#000000' : '#FFFFFF';
        const fg =
          mod.modulePrimaryColors?.theme === 'dark' ? '#FFFFFF' : '#000000';
        setNavBarBackground(bk);
        setNavBarTextColor(fg);
      } else {
        setNavBarBackground(
          mod?.backgroundColor || defaultTheme.nav.background,
        );
        setNavBarTextColor(mod?.textColor || defaultTheme.nav.text);
      }
    },
    [setNavBarTextColor, setNavBarBackground],
  );

  useEffect(() => {
    if (isNavBarFullBleed) {
      setNavBarBleed(true);
      updateNavBar(module);
    } else {
      setNavBarBleed(false);
    }

    return () => {
      setNavBarBleed(false);
    };
  }, [module, isNavBarFullBleed, updateNavBar]);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (currPos.y < prevPos.y && prevPos.y === 0) {
        // scrolling down: reset nav bar to default colors
        updateNavBar();
      } else if (currPos.y > prevPos.y && currPos.y > -1) {
        // scrolling return to 0: reset nav bar colors to first module
        updateNavBar(module);
      }
    },
    [module],
  );
};
